import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import PageTitle from 'components/PageTitle';
import Button from 'components/Button';
import CheckableInput from 'components/CheckableInput';

import { URLS } from 'config';
import { setStorage } from 'utilz';

import './styles.scss';
import containerActions from './actions';

export const budgetData = {
  250: 'Under $250 / month',
  '251-400': '$251-400 / month',
  '401-600': '$401-600 / month',
  600: 'More $600 / month'
};

const mappedElem = {
  1: 250,
  2: '251-400',
  3: '401-600',
  4: 600
};

class BudgetPage extends React.Component {
  selectBudgetHand = (e) => {
    setStorage({
      budget: {
        budget: e.target.value
      }
    });
    this.props.budgetChangeHandl(e.target.value);
  };

  render() {
    return (
      <div className="page-budget">
        <PageTitle>
          What Is Your monthly <span> Budget? </span>
        </PageTitle>
        <div className="budget-list">


          {
          Object.keys(mappedElem).map(el => (
            <CheckableInput
              name="budget"
              changeHandl={this.selectBudgetHand}
              value={mappedElem[el]}
              key={mappedElem[el]}
              checked={this.props.budget === `${mappedElem[el]}`}
            >
              {budgetData[mappedElem[el]]}
            </CheckableInput>
          ))
        }
        </div>
        <Button
          isLink
          pathTo={URLS.NEEDCAR}
          disabled={!this.props.budget}
          onClick={this.goNextHand}
        >
          Select Budget
        </Button>
      </div>
    );
  }
}
BudgetPage.propTypes = {
  budget: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]).isRequired,
  budgetChangeHandl: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  budget: state.budget.budget
});

export default connect(mapStateToProps, containerActions)(BudgetPage);



// WEBPACK FOOTER //
// ./src/pages/Budget/index.js